// extracted by mini-css-extract-plugin
export default {"input":"inputText_input__cxU2t"};